module.exports = __webpack_public_path__ + "img/gear-light.0f80d104.svg";